// Vanilla JS replacement for the former jQuery menu-hover / close-button code.
// Header menu: open <details> on hover, close on mouse leave, keep aria-expanded in sync.
document.querySelectorAll('header-menu details').forEach(function (details) {
  var summary = details.querySelector('summary');

  details.addEventListener('mouseover', function () {
    details.setAttribute('open', '');
    if (summary) summary.setAttribute('aria-expanded', 'true');
  });

  details.addEventListener('mouseout', function () {
    details.removeAttribute('open');
    if (summary) summary.setAttribute('aria-expanded', 'false');
  });
});

// Close button for the menu drawer container.
document.querySelectorAll('.colseBtn').forEach(function (btn) {
  btn.addEventListener('click', function () {
    var container = document.querySelector('#Details-menu-drawer-container');
    if (container) {
      container.removeAttribute('open');
      container.classList.remove('menu-opening');
    }
  });
});
